module.exports = __webpack_public_path__ + "static/img/bg-Client-06.60683761.png";